const initialProps = {
  curTicket: {
    id: "0",
    totalTicket: 0,
    cliente: "",
  },
};

export default function (state = initialProps, action) {
  switch (action.type) {
    case "CREATE_TICKET":
      return {
        ...state,
        curTicket: action.payload,
      };
    case "UPDATE_TICKET":
      return {
        ...state,
        curTicket: action.payload,
      };
    default:
      return state;
  }
}
